export const account = {
	email: "totem@shoppbud.com.br",
	password: "12345678",
	provider: "email",
};
